import React, { useCallback, useState, useEffect } from 'react';
import {
  getFirestore,
  collection,
  doc,
  setDoc,
  getDocs,
  deleteDoc,
  Timestamp
} from '@firebase/firestore';
import { app } from '../../firebase.js';
import { getAuth } from 'firebase/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';

function MarketingBudgetComp() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [medium, setMedium] = useState('');
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [budgets, setBudgets] = useState([]);
  const [editing, setEditing] = useState(false);
  const [editID, setEditID] = useState(null);

  const db = getFirestore(app);
  const auth = getAuth();

  const fetchBudgets = useCallback(async () => {
    try {
      const querySnapshot = await getDocs(collection(db, 'marketingBudget'));
      const data = querySnapshot.docs.map(doc => doc.data());
      const sortedData = data.sort((a, b) => b.dateAdded?.seconds - a.dateAdded?.seconds);
      setBudgets(sortedData);
    } catch (error) {
      swal('Error', error.message, 'error');
    }
  }, [db]);

  useEffect(() => {
    fetchBudgets();
  }, [fetchBudgets]);

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);

    try {
      const id = editing ? editID : `mb_${Date.now()}`;
      await setDoc(doc(db, 'marketingBudget', id), {
        medium,
        amount: parseFloat(amount),
        dateAdded: editing ? budgets.find(b => b.docID === id)?.dateAdded || Timestamp.now() : Timestamp.now(),
        createdBy: auth.currentUser ? auth.currentUser.uid : 'unknown',
        docID: id
      });

      swal('Success', `Budget ${editing ? 'updated' : 'added'}!`, 'success');
      resetForm();
      fetchBudgets();
    } catch (error) {
      swal('Error', error.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = budget => {
    setMedium(budget.medium);
    setAmount(budget.amount);
    setEditID(budget.docID);
    setEditing(true);
    setShowModal(true);
  };

    const handleDelete = async (id) => {
    swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this budget!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
    }).then(async (willDelete) => {
        if (willDelete) {
        try {
            await deleteDoc(doc(db, 'marketingBudget', id));
            swal('Deleted!', 'Budget has been deleted.', 'success');
            fetchBudgets();
        } catch (error) {
            swal('Error', error.message, 'error');
        }
        }
    });
    };


  const resetForm = () => {
    setMedium('');
    setAmount('');
    setEditID(null);
    setEditing(false);
    setShowModal(false);
  };

  const formatDate = timestamp => {
    if (!timestamp) return '';
    const date = timestamp.toDate();
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  };

  return (
    <div className='teamsComponent'>
      <div className='teamsTopBar'>
        <h5 className='tHide1'>Monthly Recurring Marketing Budget</h5>
        <div className='d-flex align-items-center gap-2 flex-wrap'>
          <button className='startOnlSessBtn startOnlSessBtn2' onClick={() => navigate('/marketing-expenses')}>
            Open Expense Ledger
          </button>
          <button className='startOnlSessBtn' onClick={() => setShowModal(true)}>
            <FontAwesomeIcon icon={faPlus} className='liveSessionIcon' /> Register a Budget
          </button>
        </div>
      </div>
      <br />

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Date Added</th>
            <th>Medium</th>
            <th>Amount</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {budgets.map(budget => (
            <tr key={budget.docID}>
              <td>{formatDate(budget.dateAdded)}</td>
              <td>{budget.medium}</td>
              <td>KES {Number(budget.amount).toLocaleString()}</td>
              <td>
                <Button
                  variant='warning'
                  size='sm'
                  onClick={() => handleEdit(budget)}
                >
                  Edit
                </Button>
              </td>
              <td>
                <Button
                  variant='danger'
                  size='sm'
                  onClick={() => handleDelete(budget.docID)}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={resetForm}>
        <Modal.Header closeButton>
          <Modal.Title>{editing ? 'Edit Budget' : 'Register Marketing Budget'}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Form.Group className='mb-3'>
              <Form.Label>Marketing Medium</Form.Label>
              <Form.Control
                type='text'
                value={medium}
                onChange={e => setMedium(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className='mb-3'>
              <Form.Label>Amount</Form.Label>
              <Form.Control
                type='number'
                value={amount}
                onChange={e => setAmount(e.target.value)}
                required
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={resetForm}>
              Cancel
            </Button>
            <Button type='submit' variant='primary' disabled={loading}>
              {loading ? 'Saving...' : editing ? 'Update' : 'Submit'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default MarketingBudgetComp;
